import { useState, useCallback, useMemo } from 'react';
import dayjs from 'dayjs';

export const dashboardTabs = {
  OVERVIEW: 0,
  CATEGORIES: 1,
  GOALS: 2,
};

// Orquestra a tela do dashboard financeiro. Consumido pelas versões web e
// mobile, que ficam responsáveis apenas pela apresentação.
export function useFinancialDashboardScreen() {
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [viewByYear, setViewByYear] = useState(false);
  const [viewAllPeriod, setViewAllPeriod] = useState(false);

  const [activeTab, setActiveTab] = useState(dashboardTabs.OVERVIEW);

  const changeTab = useCallback((tab) => setActiveTab(tab), []);

  const period = useMemo(
    () => ({ selectedDate, viewByYear, viewAllPeriod }),
    [selectedDate, viewByYear, viewAllPeriod],
  );

  return {
    period,
    selectedDate,
    setSelectedDate,
    viewByYear,
    setViewByYear,
    viewAllPeriod,
    setViewAllPeriod,
    activeTab,
    changeTab,
  };
}
